var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40003640_16671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.598 8.4745C19.2595 4.5295 15.959 1.5 12 1.5C8.04099 1.5 4.73999 4.53 4.40199 8.4745L4.16249 11.2695C4.05554 12.5168 3.65737 13.7216 2.99999 14.787L2.26399 15.979C1.52549 17.1755 1.92849 18.412 3.32249 18.5975C4.91649 18.81 7.57849 19 12 19C16.4215 19 19.0835 18.81 20.6775 18.598C22.0715 18.4125 22.4745 17.176 21.736 15.9795L21 14.7875C20.3425 13.7218 19.9443 12.5167 19.8375 11.269L19.5975 8.474L19.598 8.4745Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.598 8.4745C19.2595 4.5295 15.959 1.5 12 1.5C8.04099 1.5 4.73999 4.53 4.40199 8.4745L4.16249 11.2695C4.05554 12.5168 3.65737 13.7216 2.99999 14.787L2.26399 15.979C1.52549 17.1755 1.92849 18.412 3.32249 18.5975C4.91649 18.81 7.57849 19 12 19C16.4215 19 19.083 18.81 20.6775 18.598C22.0715 18.4125 22.4745 17.176 21.736 15.9795L21 14.7875C20.3425 13.7218 19.9443 12.5167 19.8375 11.269L19.5975 8.474L19.598 8.4745Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02389 18.939C8.13268 19.9174 8.59841 20.8214 9.33198 21.4779C10.0655 22.1344 11.0154 22.4974 11.9999 22.4974C12.9843 22.4974 13.9342 22.1344 14.6678 21.4779C15.4014 20.8214 15.8671 19.9174 15.9759 18.939M1.50739 8.5C1.42439 7.1665 2.00639 3.9 4.99989 1.5M22.4924 8.5C22.5754 7.1665 21.9934 3.9 18.9999 1.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40003640_16671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyIcon);
export default __webpack_public_path__ + "static/media/notify-icon.3a785a37f2755006255e4faf5b8e23f7.svg";
export { ForwardRef as ReactComponent };